import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="privacy-notice-container">
      <div className="privacy-content">
        <>
  <p>
    <strong>PRIVACY POLICY</strong>
  </p>
  <p>
    <strong>Last updated: September 15, 2025</strong>
  </p>
  <p>
    This Privacy Notice for Consumer Equity Legal ("<strong>we</strong>," "
    <strong>us</strong>," or "<strong>our</strong>"), describes how and why we
    might access, collect, store, use, and/or share ("<strong>process</strong>")
    your personal information when you use our services ("
    <strong>Services</strong>"), including when you:
  </p>
  <ul>
    <li>
      Visit our website at consumerequitylegal.com, or any website of ours that
      links to this Privacy Notice
    </li>
    <li>
      Engage with us in other related ways, including any sales, marketing, or
      events
    </li>
  </ul>
  <p>
    <strong>Questions or concerns?</strong> Reading this Privacy Notice will
    help you understand your privacy rights and choices. We are responsible for
    making decisions about how your personal information is processed. If you do
    not agree with our policies and practices, please do not use our Services.
    If you still have any questions or concerns, please contact us
    at admin@consumerequitylegal.com.
  </p>
  <p>
    <strong>SUMMARY OF KEY POINTS</strong>
  </p>
  <p>
    This summary provides key points from our Privacy Notice, but you can find
    out more details about any of these topics by clicking the link following
    each key point or by using our{" "}
    <a href="#table-of-contents" style={{ textDecoration: "underline" }}>table of contents</a> below
    to find the section you are looking for.
  </p>
  <p>
    <strong>What personal information do we process?</strong> When you visit,
    use, or navigate our Services, we may process personal information depending
    on how you interact with us and the Services, the choices you make, and the
    products and features you use.{" "}
    <a href="#section-1" style={{ textDecoration: "underline" }}>
      Learn more about personal information you disclose to us.
    </a>
  </p>
  <p>
    <strong>Do we process any sensitive personal information?</strong> Some of
    the information may be considered "special" or "sensitive" in certain
    jurisdictions, for example your racial or ethnic origins, sexual
    orientation, and religious beliefs. We do not process sensitive personal
    information. Do we collect any infonmation from third parties? We do not
    collect any information from third parties. How do we process your
    information? We process your information to provide, improve, and administer
    our Services, communicate with you, for security and fraud prevention, and
    to comply with law. We may also process your information for other purposes
    with your consent. We process your information only when we have a valid
    legal reason to do so. Learn more about{" "}
    <a href="#section-2" style={{ textDecoration: "underline" }}>
      how we process your information.
    </a>
  </p>
  <p>
    <strong>
      In what situations and with which parties do we share personal
      information?
    </strong>{" "}
    We may share information in specific situations and with specific third
    parties.{" "}
    <a href="#section-3" style={{ textDecoration: "underline" }}>
      Learn more about when and with whom we share your personal information.
    </a>
  </p>
  <p>
    <strong>How do we keep your information safe?</strong> We have adequate
    organizational and technical processes and procedures in place to protect
    your personal information. However, no electronic transmission over the
    internet or information storage technology can be guaranteed to be 100%
    secure, so we cannot promise or guarantee that hackers, cybercriminals, or
    other unauthorized third parties will not be able to defeat our security and
    improperly collect, access, steal, or modify your information. Learn more
    about{" "}
    <a href="#section-5" style={{ textDecoration: "underline" }}>
      how we keep your information safe.
    </a>
  </p>
  <p>
    <strong>What are your rights? </strong>Depending on where you are located
    geographically, the applicable privacy law may mean you have certain rights
    regarding your personal information.{" "}
    <a href="#section-7" style={{ textDecoration: "underline" }}>
      Learn more about your privacy rights.
    </a>
  </p>
  <p>
    <strong>How do you exercise your rights?</strong> The easiest way to
    exercise your rights is by visiting{" "}
    <a href="https://www.consumerequitylegal.com/client-intake" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>
      https://www.consumerequitylegal.com/client-intake
    </a>
    , or by contacting us. We will consider and act upon any request in
    accordance with applicable data protection laws.
  </p>
  <p>
    Want to learn more about what we do with any information we collect? Review
    the Privacy Notice in full.
  </p>
  <p id="table-of-contents">
    <strong>TABLE OF CONTENTS</strong>
  </p>
  <p>
    1.{" "}
    <a href="#section-1" style={{ textDecoration: "underline" }}>
      WHAT INFORMATION DO WE COLLECT?
    </a>
  </p>
  <p>
    2.{" "}
    <a href="#section-2" style={{ textDecoration: "underline" }}>
      HOW DO WE PROCESS YOUR INFORMATION?
    </a>
  </p>
  <p>
    3.{" "}
    <a href="#section-3" style={{ textDecoration: "underline" }}>
      WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
    </a>
  </p>
  <p>
    4.{" "}
    <a href="#section-4" style={{ textDecoration: "underline" }}>
      HOW LONG DO WE KEEP YOUR INFORMATION?
    </a>
  </p>
  <p>
    5.{" "}
    <a href="#section-5" style={{ textDecoration: "underline" }}>
      HOW DO WE KEEP YOUR INFORMATION SAFE?
    </a>
  </p>
  <p>
    6.{" "}
    <a href="#section-6" style={{ textDecoration: "underline" }}>
      DO WE COLLECT INFORMATION FROM MINORS?
    </a>
  </p>
  <p>
    7.{" "}
    <a href="#section-7" style={{ textDecoration: "underline" }}>
      WHAT ARE YOUR PRIVACY RIGHTS?
    </a>
  </p>
  <p>
    8.{" "}
    <a href="#section-8" style={{ textDecoration: "underline" }}>
      CONTROLS FOR DO-NOT-TRACK FEATURES
    </a>
  </p>
  <p>
    9.{" "}
    <a href="#section-9" style={{ textDecoration: "underline" }}>
      DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?
    </a>
  </p>
  <p>
    10.{" "}
    <a href="#section-10" style={{ textDecoration: "underline" }}>
      DO WE MAKE UPDATES TO THIS NOTICE?
    </a>
  </p>
  <p>
    11.{" "}
    <a href="#section-11" style={{ textDecoration: "underline" }}>
      HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
    </a>
  </p>
  <p>
    12.{" "}
    <a href="#section-12" style={{ textDecoration: "underline" }}>
      HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
    </a>
  </p>
  <p id="section-1">
    <strong>1. WHAT INFORMATION DO WE COLLECT?</strong>
  </p>
  <p>
    <strong>Personal information you disclose to us</strong>
  </p>
  <p>
    <strong>In Short:</strong> We collect personal information that you provide
    to us.
  </p>
  <p>
    We collect personal information that you voluntarily provide to us when you
    express an interest in obtaining information about us or our products and
    Services, when you participate in activities on the Services, or otherwise
    when you contact us.
  </p>
  <p>
    <strong>Personal Information Provided by You.</strong> The personal
    information that we collect depends on the context of your interactions with
    us and the Services, the choices you make, and the products and features you
    use. The personal information we collect may include the following:
  </p>
  <ul>
    <li>names</li>
    <li>phone numbers</li>
    <li>email addresses</li>
    <li>mailing addresses</li>
    <li>job titles</li>
    <li>contact preferences</li>
    <li>contact or authentication data</li>
    <li>billing addresses</li>
  </ul>
  <p>
    <strong>Sensitive Information. </strong>We do not process sensitive
    information.
  </p>
  <p>
    All personal information that you provide to us must be true, complete, and
    accurate, and you must notify us of any changes to such personal
    information.
  </p>
  <p id="section-2">
    <strong>2. HOW DO WE PROCESS YOUR INFORMATION?</strong>
  </p>
  <p>
    <strong>In Short: </strong>We process your information to provide, improve,
    and administer our Services, communicate with you, for security and fraud
    prevention, and to comply with law. We may also process your information for
    other purposes with your consent.
  </p>
  <p>
    <strong>
      We process your personal information for a variety of reasons, depending
      on how you interact with our Services, including:
    </strong>
  </p>
  <ul>
    <li>
      <strong>
        To deliver and facilitate delivery of services to the user.
      </strong>{" "}
      We may process your information to provide you with the requested service.
      ​
    </li>
    <li>
      <strong>To protect our Services. </strong>We may process your information
      as part of our efforts to keep our Services safe and secure, including
      fraud monitoring and prevention. ​
    </li>
    <li>
      <strong>
        To evaluate and improve our Services, products, marketing, and your
        experience.
      </strong>{" "}
      We may process your information when we believe it is necessary to
      identify usage trends, determine the effectiveness of our promotional
      campaigns, and to evaluate and improve our Services, products, marketing,
      and your experience. <strong>​</strong>
    </li>
    <li>
      <strong>
        To determine the effectiveness of our marketing and promotional
        campaigns.{" "}
      </strong>
      We may process your information to better understand how to provide
      marketing and promotional campaigns that are most relevant to you.
    </li>
    <li>
      <strong>To comply with our legal obligations. </strong>We may process your
      information to comply with our legal obligations, respond to legal
      requests, and exercise, establish, or defend our legal rights.
    </li>
  </ul>
  <p id="section-3">
    <strong>
      3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
    </strong>
  </p>
  <p>
    <strong>In Short: </strong>We may share information in specific situations
    described in this section and/or with the following third parties.
  </p>
  <p>
    We may need to share your personal information in the following situations:
  </p>
  <ul>
    <li>
      <strong>Business Transfers. </strong>We may share or transfer your
      information in connection with, or during negotiations of, any merger,
      sale of company assets, financing, or acquisition of all or a portion of
      our business to another company.
    </li>
  </ul>
  <p id="section-4">
    <strong>4. HOW LONG DO WE KEEP YOUR INFORMATION?</strong>
  </p>
  <p>
    <strong>In Short: </strong>We keep your information for as long as necessary
    to fulfill the purposes outlined in this Privacy Notice unless otherwise
    required by law. We will only keep your personal information for as long as
    it is necessary for the purposes set out in this Privacy Notice, unless a
    longer retention period is required or permitted by law (such as tax,
    accounting, or other legal requirements).
  </p>
  <p>
    When we have no ongoing legitimate business need to process your personal
    information, we will either delete or anonymize such information, or, if
    this is not possible (for example, because your personal information has
    been stored in backup archives), then we will securely store your personal
    information and isolate it from any further processing until deletion is
    possible.
  </p>
  <p id="section-5">
    <strong>5. HOW DO WE KEEP YOUR INFORMATION SAFE?</strong>
  </p>
  <p>
    In Short: We aim to protect your personal information through a system of
    organizational and technical security measures.
  </p>
  <p>
    We have implemented appropriate and reasonable technical and organizational
    security measures designed to protect the security of any personal
    information we process. However, despite our safeguards and efforts to
    secure your information, no electronic transmission over the Internet or
    information storage technology can be guaranteed to be 100% secure, so we
    cannot promise or guarantee that hackers, cybercriminals, or other
    unauthorized third parties will not be able to defeat our security and
    improperly collect, access, steal, or modify your information. Although we
    will do our best to protect your personal information, transmission of
    personal information to and from our Services is at your own risk. You
    should only access the Services within a secure environment.
  </p>
  <p id="section-6">
    <strong>6. DO WE COLLECT INFORMATION FROM MINORS?</strong>
  </p>
  <p>
    <strong>In Short: </strong>We do not knowingly collect data from or market
    to children under 18 years of age.
  </p>
  <p>
    We do not knowingly collect, solicit data from, or market to children under
    18 years of age, nor do we knowingly sell such personal information. By
    using the Services, you represent that you are at least 18 or that you are
    the parent or guardian of such a minor and consent to such minor dependent's
    use of the Services. If we learn that personal information from users less
    than 18 years of age has been collected, we will deactivate the account and
    take reasonable measures to promptly delete such data from our records. If
    you become aware of any data we may have collected from children under age
    18, please contact us at admin@consumerequitylegal.com
  </p>
  <p id="section-7">
    <strong>7. WHAT ARE YOUR PRIVACY RIGHTS?</strong>
  </p>
  <p>
    <strong>In Short: </strong>You may review, change, or terminate your account
    at any time, depending on your country, province, or state of residence.
  </p>
  <p>
    <strong>
      <span style={{ textDecoration: "underline" }}>
        Withdrawing your consent:
      </span>
    </strong>{" "}
    If we are relying on your consent to process your personal information,
    which may be express and/or implied consent depending on the applicable law,
    you have the right to withdraw your consent at any time. You can withdraw
    your consent at any time by contacting us by using the contact details
    provided in the section "
    <a href="#section-11" style={{ textDecoration: "underline" }}>
      HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
    </a>
    " below.
  </p>
  <p>
    However, please note that this will not affect the lawfulness of the
    processing before its withdrawal nor, when applicable law allows, will it
    affect the processing of your personal information conducted in reliance on
    lawful processing grounds other than consent.
  </p>
  <p>
    If you have questions or comments about your privacy rights, you may email
    us at admin@consumerequitylegal.com.
  </p>
  <p id="section-8">
    <strong>8. CONTROLS FOR DO-NOT-TRACK FEATURES</strong>
  </p>
  <p>
    Most web browsers and some mobile operating systems and mobile applications
    include a Do-Not-Track ("DNT") feature or setting you can activate to signal
    your privacy preference not to have data about your online browsing
    activities monitored and collected. At this stage, no uniform technology
    standard for recognizing and implementing DNT signals has been finalized. As
    such, we do not currently respond to DNT browser signals or any other
    mechanism that automatically communicates your choice not to be tracked
    online. If a standard for online tracking is adopted that we must follow in
    the future, we will inform you about that practice in a revised version of
    this Privacy Notice.
  </p>
  <p>
    California law requires us to let you know how we respond to web browser DNT
    signals. Because there currently is not an industry or legal standard for
    recognizing or honoring DNT signals, we do not respond to them at this time.
  </p>
  <p id="section-9">
    <strong>9. DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</strong>
  </p>
  <p>
    <strong>In Short:</strong> If you are a resident of California, Colorado,
    Connecticut, Delaware, Florida, Indiana, Iowa, Kentucky, Montana, New
    Hampshire, New Jersey, Oregon, Tennessee, Texas, Utah, or Virginia, you may
    have the right to request access to and receive details about the personal
    information we maintain about you and how we have processed it, correct
    inaccuracies, get a copy of, or delete your personal information. You may
    a/so have the right to withdraw your consent to our processing of your
    personal information. These rights may be limited in some circumstances by
    applicable law. More information is provided below.
  </p>
  <p>
    <strong>Categories of Personal Information We Collect</strong>
  </p>
  <p>
    We have collected the following categories of personal information in the
    past twelve (12) months:
  </p>
  <table>
    <tbody>
      <tr>
        <td>Category</td>
        <td>Examples</td>
        <td>Collected?</td>
      </tr>
      <tr>
        <td>A. Identifiers</td>
        <td>
          Contact details, such as real name, alias, postal address, telephone
          or A. Identifiers mobile contact number, unique personal identifier,
          online identifier, YES Internet Protocol address, email address, and
          account name
        </td>
        <td>YES</td>
      </tr>
      <tr>
        <td>
          B. Personal information defined in the California Customer Records
          statue
        </td>
        <td>
          Name, contact information, education, employment, employment history,
          and financial information
        </td>
        <td>YES</td>
      </tr>
      <tr>
        <td>
          C. Protected classifications characteristics under state or federal
          law
        </td>
        <td>
          Gender, age, date of birth, race and ethnicity, national origin,
          marital status, and other demographic data
        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>D. Commercial information</td>
        <td>
          Transaction information, purchase history, financial details, and
          payment information
        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>E. Biometric information</td>
        <td>Fingerprints and voiceprints</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>F. Internet or other similar network activity</td>
        <td>
          Browsing history, search history, online behavior, interest data, and
          other interactions with our and other websites, applications, systems,
          and advertisements
        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>G. Geolocation data</td>
        <td>Device location</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>H. Audio, electronic, sensory, or similar information</td>
        <td>
          Images and audio, video or call recordings created in connection with
          our business activies
        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>I. Professional or employment-related information</td>
        <td>
          Business contact details in order to provide you our Services at a
          business level or job title, work history, and professional
          qualifications if you apply for a job with us
        </td>
        <td>YES</td>
      </tr>
      <tr>
        <td>J. Education Information</td>
        <td>Student records and directory information</td>
        <td>NO</td>
      </tr>
      <tr>
        <td>K. Inferences drawn from collected personal information</td>
        <td>
          Inferences drawn from any of the collected personal information listed
          above to create a profile or summary about, for example, an
          individual's preferences and characteristics
        </td>
        <td>NO</td>
      </tr>
      <tr>
        <td>L. Sensitive personal information</td>
        <td></td>
        <td>NO</td>
      </tr>
    </tbody>
  </table>
  <p>
    We may also collect other personal information outside of these categories
    through instances where you interact with us in person, online, or by phone
    or mail in the context of:
  </p>
  <ul>
    <li>Receiving help through our customer support channels;</li>
    <li>Participation in customer surveys or contests; and</li>
    <li>
      Facilitation in the delivery of our Services and to respond to your
      inquiries.
    </li>
  </ul>
  <p>
    We will use and retain the collected personal information as needed to
    provide the Services or for:
  </p>
  <ul>
    <li>Category A - As long as the user has an account with us</li>
    <li>Category B - As long as the user has an account with us</li>
    <li>Category I - As long as the user has an account with us</li>
  </ul>
  <p>
    <strong>Sources of Personal Information</strong>
  </p>
  <p>
    Learn more about the sources of personal information we collect in "
    <a href="#section-1" style={{ textDecoration: "underline" }}>
      WHAT INFORMATION DO WE COLLECT?
    </a>
    "
  </p>
  <p>
    <strong>How We Use and Share Personal Information</strong>
  </p>
  <p>
    Learn about how we use your personal information in the section, "
    <a href="#section-2" style={{ textDecoration: "underline" }}>
      HOW DO WE PROCESS YOUR INFORMATION?
    </a>
    "
  </p>
  <p>
    <strong>Will your information be shared with anyone else?</strong>
  </p>
  <p>
    We may disclose your personal information with our service providers
    pursuant to a written contract between us and each service provider. Learn
    more about how we disclose personal information to in the section, "
    <a href="#section-3" style={{ textDecoration: "underline" }}>
      WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
    </a>
    "
  </p>
  <p>
    We may use your personal information for our own business purposes, such as
    for undertaking internal research for technological development and
    demonstration. This is not considered to be "selling" of your personal
    information.
  </p>
  <p>
    We have not disclosed, sold, or shared any personal information to third
    parties for a business or commercial purpose in the preceding twelve ( 12)
  </p>
  <p>
    months. We will not sell or share personal information in the future
    belonging to website visitors, users, and other consumers.
  </p>
  <p>
    <strong>Your Rights</strong>
  </p>
  <p>
    You have rights under certain US state data protection laws. However, these
    rights are not absolute, and in certain cases, we may decline your request
    as permitted by law. These rights include:
  </p>
  <ul>
    <li>
      <strong>Right to know</strong> whether or not we are processing your
      personal data
    </li>
    <li>
      <strong>Right to access</strong> your personal data
    </li>
    <li>
      <strong>Right to correct</strong> inaccuracies in your personal data
    </li>
    <li>
      <strong>Right to request</strong> the deletion of your personal data
    </li>
    <li>
      <strong>Right to obtain a copy</strong> of the personal data you
      previously shared with us
    </li>
    <li>
      <strong>Right to non-discrimination</strong> for exercising your rights
    </li>
    <li>
      <strong>Right to opt out</strong> of the processing of your personal data
      if ii is used for targeted advertising (or sharing as defined under
      California's privacy law), the sale of personal data, or profiling in
      furtherance of decisions that produce legal or similarly significant
      effects ("profiling")​​
    </li>
  </ul>
  <p>
    Depending upon the state where you live, you may also have the following
    rights:
  </p>
  <ul>
    <li>
      Right to obtain a list of the categories of third parties to which we have
      disclosed personal data (as permitted by applicable law, including
      California's and Delaware's privacy law)
    </li>
    <li>
      Right to obtain a list of specific third parties to which we have
      disclosed personal data (as permitted by applicable law, including
      Oregon's privacy law)
    </li>
    <li>
      Right to limit use and disclosure of sensitive personal data (as permitted
      by applicable law, including California's privacy law)
    </li>
    <li>
      Right to opt out of the collection of sensitive data and personal data
      collected through the operation of a voice or facial recognition feature
      (as permitted by applicable law, including Florida's privacy law)
    </li>
  </ul>
  <p>
    <strong>How to Exercise Your Rights</strong>
  </p>
  <p>
    To exercise these rights, you can contact us by visiting{" "}
    <a href="https://www.consumerequitylegal.com/client-intake" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "underline" }}>
      https://www.consumerequitylegal.com/client-intake
    </a>
    , by calling toll-free at 9518401541, or by referring to the contact details
    at the bottom of this page.
  </p>
  <p>
    Under certain US state data protection laws, you can designate an authorized
    agent to make a request on your behalf. We may deny a request from an
    authorized agent that does not submit proof that they have been validly
    authorized to act on your behalf in accordance with applicable laws.
  </p>
  <p>
    <strong>Request Verification</strong>
  </p>
  <p>
    Upon receiving your request, we will need to verify your identity to
    determine you are the same person about whom we have the information in our
    system. We will only use personal information provided in your request to
    verify your identity or authority to make the request. However, if we cannot
    verify your identity from the information already maintained by us, we may
    request that you provide additional information for the purposes of
    verifying your identity and for security or fraud-prevention purposes.
  </p>
  <p>
    If you submit the request through an authorized agent, we may need to
    collect additional information to verify your identity before processing
    your request and the agent will need to provide a written and signed
    permission from you to submit such request on your behalf.
  </p>
  <p>
    <strong>Appeals</strong>
  </p>
  <p>
    Under certain US state data protection laws, if we decline to take action
    regarding your request, you may appeal our decision by emailing us at
    admin@consumerequitylegal.com. We will inform you in writing of any action
    taken or not taken in response to the appeal, including a written
    explanation of the reasons for the decisions. If your appeal is denied, you
    may submit a complaint to your state attorney general.
  </p>
  <p>
    <strong>California "Shine The Light"</strong>
  </p>
  <p>
    Law California Civil Code Section 1798.83, also known as the "Shine The
    Light" law, permits our users who are California residents to request and
    obtain from us, once a year and free of charge, information about categories
    of personal information (if any) we disclosed to third parties for direct
    marketing purposes and the names and addresses of all third parties with
    which we shared personal information in the immediately preceding calendar
    year. If you are a California resident and would like to make such a
    request, please submit your request in writing to us by using the contact
    details provided in the section "
    <a href="#section-13">HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</a>
    "
  </p>
  <p id="section-10">
    <strong>10. DO WE MAKE UPDATES TO THIS NOTICE?</strong>
  </p>
  <p>
    In Short: Yes, we will update this notice as necessary to stay compliant
    with relevant laws.
  </p>
  <p>
    We may update this Privacy Notice from time to time. The updated version
    will be indicated by an updated "Revised" date at the top of this Privacy
    Notice. If we make material changes to this Privacy Notice, we may notify
    you either by prominently posting a notice of such changes or by directly
    sending you a notification. We encourage you to review this Privacy Notice
    frequently to be informed of how we are protecting your information.
  </p>
  <p id="section-11">
    <strong>11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</strong>
  </p>
  <p>
    If you have questions or comments about this notice, you may contact us by
    post at:
  </p>
  <p>Consumer Equity Legal</p>
  <p>43537 Ridge Park Dr. STE 100</p>
  <p>Temecula, CA 92590</p>
  <p>United States</p>
  <p>​</p>
  <p>Or by emailing admin@consumerequitylegal.com</p>
  <p id="section-12">
    <strong>
      12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
    </strong>
  </p>
  <p>
    You have the right to request access to the personal information we collect
    from you, details about how we have processed it, correct inaccuracies, or
    delete your personal information. You may also have the right to withdraw
    your consent to our processing of your personal information. These rights
    may be limited in some circumstances by applicable law. To request to
    review, update, or delete your personal information, please visit:{" "}
    <a 
      href="https://www.consumerequitylegal.com/client-intake" 
      target="_blank" 
      rel="noopener noreferrer"
    >
      https://www.consumerequitylegal.com/client-intake
    </a>
    .
  </p>
</>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
